import {create} from 'zustand';

// Loader global de pantalla completa, INDEPENDIENTE del sistema de diálogos.
// Necesario porque el store de diálogos sólo mantiene un diálogo a la vez: al abrir
// el modal de TOTP se reemplaza (desmonta) el diálogo de firma, por lo que su loader
// interno ya no puede mostrarse mientras corre el proceso. Este loader vive en el
// provider raíz y se controla por funciones sueltas (como openDialog), así que sigue
// visible aunque el diálogo que lo disparó ya no esté montado.
interface GlobalLoaderStore {
  visible: boolean;
  message: string;
  show: (message?: string) => void;
  update: (message: string) => void;
  hide: () => void;
}

export const useGlobalLoaderStore = create<GlobalLoaderStore>()(set => ({
  visible: false,
  message: '',
  show: (message = '') => set({visible: true, message}),
  update: (message: string) => set({message}),
  hide: () => set({visible: false, message: ''}),
}));

export const showGlobalLoader = (message?: string): void =>
  useGlobalLoaderStore.getState().show(message);
export const updateGlobalLoader = (message: string): void =>
  useGlobalLoaderStore.getState().update(message);
export const hideGlobalLoader = (): void =>
  useGlobalLoaderStore.getState().hide();
